// File generated automatically. Do not edit manually.
import keys from "./keys";

const translate: { [k: string]: string } = {
  [keys.INS_understandWhatWorksBest]: "Entenda o que é mais eficaz",
  [keys.INS_trackedConversion]: "Conversão selecionada",
  [keys.INS_conversationsFrom]: "Conversas de",
  [keys.INS_whereLeads]: "onde levam",
  [keys.INS_editConversions]: "Edite a conversão",
  [keys.INS_edit]: "Edite",
  [keys.INS_allSources]: "Todas as origens",
  [keys.INS_incoming]: "Que entra",
  [keys.INS_outgoing]: "Que saí",
  [keys.INS_organic]: "Mensagens orgânicas",
  [keys.INS_sourceName]: "Titulo da origem",
  [keys.INS_sourceBreakdown]: "Detalhes das origens",
  [keys.INS_startedConversations]: "Conversas iniciadas",
  [keys.INS_conversionRate]: "Taxa de conversão",
  [keys.INS_convertedLeads]: "Leads convertidos",
  [keys.INS_invested]: "Investido",
  [keys.INS_revenue]: "Receita",
  [keys.INS_downloadLeads]: "Download os leads",
  [keys.INS_searchNumber]: "Procure por um número",
  [keys.INS_downloadAllLeads]: "Leads",
  [keys.INS_saveEvent]: "Salvar Evento",
  [keys.INS_saveEventSubtitle]:
    "Garanta a correspondência exata dos caracteres ao rastrear uma mensagem do WhatsApp, para obter resultados precisos.",
  [keys.INS_notificationEventCreated]: "Evento criado com sucesso",
  [keys.INS_saveEventTooltip]: "Rastrear mensagem do WhatsApp",
  [keys.INS_writeTheEvent]: "Escreva a mensagem do evento",
  [keys.INS_saveEventLabel]: "Mensagem do WhatsApp a ser rastreada",
  [keys.INS_confirm]: "Confirmar",
  [keys.INS_downloadAllLeadsDescription]:
    "Baixe todos os leads cadastrados no intervalo de tempo selecionado, sem nenhum filtro específico aplicado.",
  [keys.INS_leadsDescription]: "Leads que iniciaram uma conversa",
  [keys.INS_percentageLeads]:
    "Porcentagem de leads que dispararam um evento de conversão",
  [keys.INS_leadsConversion]:
    "Total de leads que dispararam um evento de conversão",
  [keys.INS_investedDescription]:
    "Quantidade investida para disparar eventos de conversão",
  [keys.INS_conversionCost]:
    "O custo associado a cada aquisição bem-sucedida de leads, com base no valor investido",
  [keys.INS_revenueDescription]:
    "Quantidade de renda gerada através desse evento de conversão",
  [keys.INS_returnDescription]:
    "O Retorno sobre o investimento em publicidade (ROAS) é a receita gerada por cada unidade de moeda investida",
  [keys.INS_impressionsTitle]: "Impressões Totais",
  [keys.INS_impressionsDescription]:
    "Número de vezes que um anúncio foi carregado na página",
  [keys.INS_paidClicksTitle]: "Cliques Pagos",
  [keys.INS_paidClicksDescription]: "Quantidade de cliques em um anúncio CTWA",
  [keys.INS_roasDescription]: "ROAS não disponível.",
  [keys.INS_learnEnable]: " Aprenda mais sobre como habilitá-lo",
  [keys.INS_costPerConversion]: "Custo Por Conversão",
  [keys.INS_revenueNotAvailable]: "ROAS não disponível",
  [keys.INS_adsFrom]: "Anúncios de → Todos os conjuntos de Anúncio",
  [keys.INS_sourceInfo]: "Informação da origem",
  [keys.INS_detailedInfo]: "Informações detalhadas da origem selecionada",
  [keys.INS_typeLabel]: "Tipo",
  [keys.INS_typeInfo]: "Meta",
  [keys.INS_typeDescription]:
    "Origens do tipo Meta são anúncios de Clique para o WhatsApp",
  [keys.INS_incomingCustom]: "Origem de entrada",
  [keys.INS_incomingCustomDescription]:
    "Origens de entrada são origens onde o lead iniciou uma conversa. Podendo ser através de QR Codes, WA.me links, etc.",
  [keys.INS_giveThisSourceName]: "Dê um nome para a origem",
  [keys.INS_yesterday]: "Ontem",
  [keys.INS_enableIt]: "Habilite",
  [keys.INS_steps]: "step(s)",
  [keys.INS_createNewFunnel]: "Criar novo funil",
  [keys.INS_nameFunnel]: "Nomear funil",
  [keys.INS_replaceEvent]: "Substituir por outro evento",
  [keys.INS_selectEvent]: "Selecionar um evento",
  [keys.INS_removeEvent]: "Remover evento do funil",
  [keys.INS_mustNotExceed20]: "O nome não deve exceder 20 caracteres",
  [keys.INS_costPerAcquisition]: "Custo por Aquisição",
  [keys.INS_inThreadEvent]: "Evento in-thread",
  [keys.INS_offThreadEvent]: "Evento off-thread",
  [keys.INS_funnelUpdated]: "Funil atualizado",
  [keys.INS_sourceTypes]: "Todas as origens",
  [keys.INS_sources]: "Origens",
  [keys.INS_sourcesDescription]:
    "Tipos de fontes usadas para promover conversas",
  [keys.INS_messages]: "Mensagens",
  [keys.INS_adSets]: "Anúncios",
  [keys.INS_adSet]: "Anúncio",
  [keys.INS_folders]: "Pastas",
  [keys.INS_ads]: "Anúncios",
  [keys.INS_campaigns]: "Campanhas",
  [keys.INS_metaClickToWhatsApp]: "Campanhas CTWA",
  [keys.INS_metaCTWA]: "Meta CTWA",
  [keys.INS_incomingCampaigns]: "Mensagens recebidas",
  [keys.INS_outgoingTemplates]: "Mensagens enviadas",
  [keys.INS_open]: "Abrir",
  [keys.INS_custom]: "Custom",
  [keys.INS_lastWeek]: "Última semana",
  [keys.INS_last2Weeks]: "Últimas 2 semanas",
  [keys.INS_lastMonth]: "Último mês",
  [keys.INS_cancel]: "Cancelar",
  [keys.INS_apply]: "Aplicar",
  [keys.INS_bestRoas]: "Alto engajamento",
  [keys.INS_bestRoasTooltip]:
    "Parece que este anúncio está tendo um desempenho consideravelmente melhor do que os outros deste mesmo conjunto de anúncios.",
  [keys.INS_bestRoasTooltipLink]: "Aprenda como melhorar o desempenho geral",
  [keys.INS_worstRoas]: "Baixo engajamento",
  [keys.INS_worstRoasTooltip]:
    "Parece que este anúncio está tendo um desempenho consideravelmente pior do que os outros deste mesmo conjunto de anúncios.",
  [keys.INS_worstRoasTooltipLink]: "Aprenda como melhorar seu desempenho",
  // [keys.INS_orderingFilter]: "translation_missing",
  //  [keys.INS_selectEventToViewDetails]: "translation_missing",
  [keys.INS_details]: "Detalhes",
  [keys.INS_orderingBtnDescription]: "Ordenando as colunas por",
  [keys.INS_applyFunnel]: "Aplicar funil",
  [keys.INS_funnelApplied]: "Funil aplicado",
  [keys.INS_applyFunnelButtonTooltip]:
    "Buscar as colunas de Taxa de conversão e Leads convertidos baseado nos eventos do Funil.",
  [keys.INS_applyFunnelDisabledButtonTooltip]:
    "Adicione pelo menos 2 eventos no Funil para aplicá-los na tabela.",
  [keys.INS_overallAverage]: "Média geral para datas selecionadas",
  // [keys.INS_noDataAvailable]: "translation_missing",
  // [keys.INS_noDataAvailableDescription]: "translation_missing",
  // [keys.INS_openMetaBusinessManager]: "translation_missing",
  [keys.INS_cpaChartAveragePopoverText]:
    "O Custo por Aquisição médio da sua campanha",
  [keys.INS_cpaChartBenchmarkPopoverText]:
    "O CPA médio do mercado para o seu país e setor",
  [keys.INS_cpaChartTitle1]: "Custo por Aquisição CTWA Anúncios Pagos ",
  [keys.INS_cpaChartTitle2]: "/campanhas",
  [keys.INS_cpaChartDescription1]:
    "Veja abaixo todas as suas campanhas, organizadas por nome (de A a Z), exibidas de acordo com o Custo por Aquisição. Esse valor é calculado dividindo",
  [keys.INS_cpaChartDescription2]:
    "o total investido em campanhas pelo número de novos clientes, leads ou assinantes.",
  [keys.INS_cpaChartHigh]: "Alto",
  [keys.INS_cpaChartAttention]: "Atenção",
  [keys.INS_cpaChartLow]: "Baixo",
  [keys.INS_performanceReportListTitle]: "Análise de Performance",
  [keys.INS_performanceReportListDescription]:
    "Encontre abaixo um resumo do desempenho da sua campanha, destacando pontos fortes e áreas para melhoria.",
  [keys.INS_templatesReportListTitle]: "Análise de desempenho dos templates",
  [keys.INS_templatesReportListDescription]:
    "Encontre abaixo um resumo do desempenho dos seus templates, destacando pontos fortes e áreas para melhoria.",
  [keys.INS_marketingMessagesChartTitle1]:
    "Taxa de Conversão das mensagens de marketing",
  [keys.INS_marketingMessagesChartTitle2]: "/templates",
  [keys.INS_marketingMessagesChartDescription1]:
    "Encontre abaixo os templates selecionados, exibidos pela sua Taxa de Conversão (%). Isso é calculado dividindo sua audiência",
  [keys.INS_marketingMessagesChartDescription2]:
    "pela quantidade de usuários que converteram na última etapa do seu funil.",
  [keys.INS_highlightAllPerformances]: "Destacar todos os desempenhos",
  [keys.INS_showHighPerformance]: "Mostrar alto desempenho",
  [keys.INS_showMidPerformance]: "Mostrar desempenho médio",
  [keys.INS_showLowPerformance]: "Mostrar baixo desempenho",
  [keys.INS_showLearningPhase]: "Mostrar fase de aprendizado",
  [keys.INS_clear]: "Limpar",
  [keys.INS_notEnoughData]:
    "Não há dados suficientes para a lista de relatórios.",
};

export default translate;
